<bs-linear-container-summary [msAutomation]="pickId.toString()" [isDisabled]="isDisabled" />
